import React from 'react';
import { IoIosSearch } from 'react-icons/io';
import { InputControlMask } from './InputControlMask';

const Input = (
    {
        id,
        field = '',
        label,
        type = 'text',
        placeholder = '',
        value = '',
        classNameInput = '',
        onChange = () => '',
        mask = '',
        pattern = undefined,
        title = '',
        required = true,
        icon = undefined,
        useIconInfo = false,
        typeImgInfo = '',
        useiconSearch = false,
        labelLeft = '',
        readOnly = false,
        max = 0,
        labelInfo = '',
        onClickIconSearch = () => '',
    }
) => {

    const cssClassInput = ` input-field ${classNameInput} `;

    const control = {
        textarea: <textarea
            rows="2"
            id={id}
            name={field}
            onChange={onChange}
            className={'txt-left' + cssClassInput}
            type={type}
            placeholder={placeholder}
            value={value}
            required={required}
        ></textarea>,
        text: <input
            id={id}
            name={field}
            onChange={onChange}
            className={cssClassInput}
            type={type}
            placeholder={placeholder}
            value={value}
            required={required}
            pattern={pattern}
            title={title}
            readOnly={readOnly}
        />,
        email: <input
            id={id}
            name={field}
            onChange={onChange}
            className={cssClassInput}
            type={type}
            placeholder={placeholder}
            value={value}
            required={required}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"

        />,
        number: <input
            id={id}
            name={field}
            onChange={onChange}
            className={cssClassInput}
            type={type}
            placeholder={placeholder}
            value={value}
            required={required}
            min="0"
            suffix={'%'}
        />,
        mask: <InputControlMask
            name={field}
            onChange={onChange}
            className={cssClassInput}
            type={type}
            id={id}
            placeholder={placeholder}
            value={value}
            mask={mask}
            required={required}
            pattern={pattern}
            title={title}

        />
    }

    return (
        <div>
            <div className="lbl-input">
                <span> {label} </span>
            </div>
            <div className="control-input-with-btn wrapper">
                {labelLeft != '' && <div className="input-field-left"><span className="txt-input-left">{labelLeft}</span></div>}
                {control[type]}
                {useiconSearch === true && (
                    <IoIosSearch className="icon-search" onClick={onClickIconSearch} />
                )}
            </div>
            <div className="label-info-switch">
                {labelInfo}
             </div>

        </div>
    );
};

export { Input }
